import { PageActionDiscriminator } from 'autogen/swagger/all';
import type { PageActionModel } from '../../PageAction';
import { generateDummyCustomActionModel } from '../CustomAction/shared/helpers';
import { generateDummyLinkActionModel } from '../LinkAction/shared/helpers';
import type { components } from 'autogen/swagger/all/all';

type PageActionTypes = 'CustomPageActionType' | 'LinkActionType';

export function generateDummyPageActionModel(type: PageActionTypes = 'LinkActionType', url = '#'): PageActionModel {
    switch (type) {
        case 'CustomPageActionType':
            return { $type: 'CustomPageActionType', action: generateDummyCustomActionModel() };
        case 'LinkActionType':
            return { $type: 'LinkActionType', action: generateDummyLinkActionModel(url) };
        default:
            return { $type: 'LinkActionType', action: generateDummyLinkActionModel(url) };
    }
}

export function guardIsPageActionOfTypeLinkAction(pageAction?: PageActionModel) {
    if (!pageAction) return undefined;

    return PageActionDiscriminator(
        pageAction,
        (customPageAction) => undefined,
        (linkAction) => linkAction,
        () => undefined
    );
}

export function guardIsPageActionOfTypeCustomAction(pageAction?: PageActionModel) {
    if (!pageAction) return undefined;

    return PageActionDiscriminator(
        pageAction,
        (customPageAction) => customPageAction,
        (linkAction) => undefined,
        () => undefined
    );
}
